export const BRIEF_CONTENT_TAB = 'Brief Content'
export const EMAIL_DETAILS_TAB = 'Email Details'
export const CHOOSE_RECIPIENTS_TAB = 'Choose Recipients'
export const CONFIRM_AND_SEND_TAB = 'Confirm and Send'

export type BriefNavSteps =
  | typeof BRIEF_CONTENT_TAB
  | typeof EMAIL_DETAILS_TAB
  | typeof CHOOSE_RECIPIENTS_TAB
  | typeof CONFIRM_AND_SEND_TAB

export const NAVIGATION_STEPS: BriefNavSteps[] = [
  BRIEF_CONTENT_TAB,
  EMAIL_DETAILS_TAB,
  CHOOSE_RECIPIENTS_TAB,
  CONFIRM_AND_SEND_TAB,
]

export const getStepLink = (briefId: string, step: BriefNavSteps) => {
  if (!briefId) return null

  const pathMap: Record<BriefNavSteps, string> = {
    [BRIEF_CONTENT_TAB]: 'content',
    [EMAIL_DETAILS_TAB]: 'email',
    [CHOOSE_RECIPIENTS_TAB]: 'recipients',
    [CONFIRM_AND_SEND_TAB]: 'confirm',
  }

  return `/brief-editor/${briefId}/${pathMap[step]}`
}
